module.exports = __webpack_public_path__ + "static/media/cleaning-1.97ada17d.jpg";